<template>
    <v-container container--fluid grid-list-lg>
        <v-layout row align-center justify-center>
            <v-flex xs12 md6 class="text-center">
                <div>
                    <p class="title">Welcome to {{ appNameUrls.client }} - Team Entry online registration system.</p>
                    <p class="body">Please select from one of the following:</p>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row align-center justify-space-around>
            <v-flex xs12 md6 class="text-center">
                <v-card ripple dark color="primary" :to="{ name: 'login' }" class="py-3 elevation-6">
                    <v-icon x-large color="darken-2">launch</v-icon>
                    <v-card-text class="px-0 caption">Existing Manager log-in</v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 md6 class="text-center">
                <v-card dark ripple color="primary" :to="{ name: 'registerteamentry' }" class="py-3 elevation-6">
                    <v-icon x-large color="darken-2">input</v-icon>
                    <v-card-text class="px-0 caption">New Manager create user</v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: "TeamEntry",
    components: {
        //
    },
    data() {
        return {
            //
        };
    },
};
</script>

<style scoped></style>
